var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "object-menu-container",
      style: [_vm.xPosition, _vm.yPosition],
      attrs: { "data-app": "" }
    },
    [
      _c(
        "object-menu-item",
        {
          attrs: {
            disabled: !_vm.hasPermission("show"),
            action: _vm.$t("View")
          },
          nativeOn: {
            click: function($event) {
              return _vm.openForm("view")
            }
          }
        },
        [_c("ViewSVG")],
        1
      ),
      _vm._v(" "),
      _c(
        "object-menu-item",
        {
          attrs: {
            disabled: !_vm.hasPermission("show"),
            action: _vm.$tc("Detail", 2)
          },
          nativeOn: {
            click: function($event) {
              return _vm.openDetailForm()
            }
          }
        },
        [_c("DetailSVG")],
        1
      ),
      _vm._v(" "),
      _c(
        "object-menu-item",
        {
          attrs: {
            disabled: !_vm.hasPermission("update"),
            action: _vm.$t("Edit")
          },
          nativeOn: {
            click: function($event) {
              return _vm.openForm("edit")
            }
          }
        },
        [_c("EditSVG")],
        1
      ),
      _vm._v(" "),
      _vm.actionFrom === "fc_microduct_bundle"
        ? _c(
            "object-menu-item",
            {
              attrs: {
                disabled: false,
                action: _vm.object.split ? _vm.$t("Join") : _vm.$t("Split")
              },
              nativeOn: {
                click: function($event) {
                  return _vm.$emit("splitBundle", _vm.object.uuid)
                }
              }
            },
            [
              _c(
                "v-icon",
                { staticStyle: { left: "-3px", "margin-right": "-6px" } },
                [
                  _vm._v(
                    _vm._s(_vm.object.split ? "linear_scale" : "alt_route")
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !(_vm.actionFrom === "fc_cluster_tool" && _vm.object.type === "Closure")
        ? _c(
            "object-menu-item",
            {
              attrs: { action: _vm.$t("Remove") },
              nativeOn: {
                click: function($event) {
                  return _vm.$emit("removeFromCable", _vm.object.uuid)
                }
              }
            },
            [_c("RemoveSVG")],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-82e9e86e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82e9e86e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/ObjectMenu/WindowObjectMenu.vue
// module id = null
// module chunks = 